export const environment = {
  production: false,
  identityApi: `#{identityServerUrl}#`,
  reportsApi: `#{reportsApiUrl}#`,
  helpUrl: `https://performa365-report.readthedocs.io`,
  examApi: `#{examApiUrl}`
};
